import { render } from "./RecentPagesSection.vue?vue&type=template&id=2bec9856&scoped=true"
import script from "./RecentPagesSection.vue?vue&type=script&lang=js"
export * from "./RecentPagesSection.vue?vue&type=script&lang=js"

import "./RecentPagesSection.vue?vue&type=style&index=0&id=2bec9856&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bec9856"]])

export default __exports__